import { createSlice } from "@reduxjs/toolkit";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    loading: false,
    error: null,
    userProperties: [],
    yearToDatePropertiesStatus: [],
    totalPropertiesWorth: []
  },
  reducers: {
    userPropertiesCountRequest: (state) => {
      state.userProperties = [];
      state.loading = true;
      state.error = null;
    },
    userPropertiesCountSuccess: (state, action) => {
      const data = action.payload;
      state.userProperties = data;
      state.loading = false;
      state.error = null;
    },
    userPropertiesCountFailure: (state, action) => {
      state.error = action.payload?.response?.data?.details;
      state.loading = false;
    },
    userPropertiesCountYearToDateRequest: (state) => {
      state.yearToDatePropertiesStatus = [];
      state.loading = true;
      state.error = null;
    },
    userPropertiesCountYearToDateSuccess: (state, action) => {
      const data = action.payload;
      state.yearToDatePropertiesStatus = data;
      state.loading = false;
      state.error = null;
    },
    userPropertiesCountYearToDateFailure: (state, action) => {
      state.error = action.payload?.response?.data?.details;
      state.loading = false;
    },
    userTotalPropertiesWorthRequest: (state) => {
      state.totalPropertiesWorth = [];
      state.loading = true;
      state.error = null;
    },
    userTotalPropertiesWorthSuccess: (state, action) => {
      const data = action.payload;
      state.totalPropertiesWorth = data;
      state.loading = false;
      state.error = null;
    },
    userTotalPropertiesWorthFailure: (state, action) => {
      state.error = action.payload?.response?.data?.details;
      state.loading = false;
    }
  }
});

export const {
  userPropertiesCountRequest,
  userPropertiesCountSuccess,
  userPropertiesCountFailure,
  userPropertiesCountYearToDateRequest,
  userPropertiesCountYearToDateSuccess,
  userPropertiesCountYearToDateFailure,
  userTotalPropertiesWorthRequest,
  userTotalPropertiesWorthSuccess,
  userTotalPropertiesWorthFailure
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
